<template>
  <v-container>
    <taxAdditionsUI />
  </v-container>
</template>

<script>
import taxAdditionsUI from '../../components/shared/taxAdditions/taxAdditionsList.vue';

export default {
  name: 'taxAdditions',
  components: {
    taxAdditionsUI,
  },
};
</script>
